var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeal = function SvgIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ideal_svg__a",
    d: "M.223.653v32.511h19.784c11.96 0 18.55-5.786 18.55-16.295 0-6.054-2.41-16.216-18.55-16.216H.223zM1.78 2.18h18.227c10.501 0 16.991 4.691 16.991 14.69 0 9.73-5.986 14.764-16.991 14.764H1.78V2.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ideal_svg__c",
    d: "M.238 4.143c0 1.967 1.625 3.561 3.627 3.561 2.003 0 3.627-1.594 3.627-3.56 0-1.964-1.624-3.56-3.627-3.56C1.863.584.238 2.18.238 4.144z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ideal_svg__e",
    d: "M.692.373v6.009h1.04c1.89 0 3.065 1.258 3.065 3.284 0 2.09-1.147 3.338-3.065 3.338H.692v12.022h7.011c10.687 0 14.407-4.874 14.539-12.022h-4.219V6.377h1.68v4.978h2.49C21.51 2.323 14.275.373 7.703.373H.692zm12.061 6.004h2.392l2.033 6.629h-1.75l-.38-1.282H12.85l-.383 1.282h-1.75l2.036-6.63zm-7 .003h4.022v1.65H7.433v.769h2.215v1.649H7.433v.907H9.91v1.649H5.753V6.38zM.69 8.031v3.324h1.042c.718 0 1.381-.205 1.381-1.69 0-1.449-.738-1.634-1.381-1.634H.69zm13.208.17-.558 1.874h1.217L14 8.2h-.102z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.633 36.134h21.85l7.28-1.944 4.957-4.219 2.425-6.634v-7.666l-3.627-6.159-6.323-3.499-6.092-.501-20.47-.301z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.5 3.548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ideal_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ideal_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M-1 34.364h40.778V-.548H-1z",
    mask: "url(#ideal_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M20.79 32.838h5.833V22.642H20.79z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.833 13.366)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ideal_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ideal_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M-.983 8.903h9.696v-9.52H-.983z",
    mask: "url(#ideal_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.833 7.82)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ideal_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ideal_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D50172",
    d: "M-.532 26.224h23.995V-.827H-.532z",
    mask: "url(#ideal_svg__f)"
  })))));
};
export default SvgIdeal;